'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mqttws = require('./mqttws31');

var _mqttws2 = _interopRequireDefault(_mqttws);

var _constants = require('../common/constants');

var Constants = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MqttClient = function MqttClient() {
    var _this = this;

    _classCallCheck(this, MqttClient);

    this.connect = function (conOpts, callback) {

        if (_this.isConnecting) {
            callback(null, {
                status: "failed",
                data: "connecting"
            });
            return;
        }

        if (_this.isConnected) {
            _this.totalClientConnections++;
            callback(null, {
                status: "success",
                data: _this.connectionObject
            });
            return;
        }

        // validate args
        if (!(conOpts.clientId && conOpts.port && conOpts.host && conOpts.autoConnect && conOpts.willData)) {
            throw new Error("Invalid connection option values");
        } else {
            _this.clientId = conOpts.clientId;
            _this.port = conOpts.port;
            _this.host = conOpts.host;
            _this.autoConnect = conOpts.autoConnect;
            _this.willData = conOpts.willData;
            _this.willData.payload.client_id = _this.clientId;
        }

        _this.isConnecting = true;
        var mqttClient = new _mqttws2.default.MQTT.Client(_this.host, Number(_this.port), _this.clientId);
        // set the callback handlers
        mqttClient.onConnectionLost = _this._onConnectionLost;
        mqttClient.onMessageArrived = _this._onMessageArrived;

        var willMessage = new _mqttws2.default.MQTT.Message(JSON.stringify(_this.willData.payload));
        willMessage.destinationName = _this.willData.topic;
        willMessage.qos = _this.willData.qos;

        console.log(willMessage);

        conOpts = {
            timeout: 60, // connect timeout
            onSuccess: function onSuccess(rc) {
                _this.isConnected = true;
                _this.connectionObject = rc;
                _this.totalClientConnections++;
                _this.isConnecting = false;

                //console.log("MqttClient.onConnect: CONNACK ", rc)
                callback(null, {
                    status: "success",
                    data: rc
                });
                _this._connectionStatusChange(Constants.MQTT_ONLINE);
            },
            onFailure: function onFailure(res) {
                _this.isConnecting = false;
                // console.log("MqttClient.onDisconnect: Lost mqttClient ", res.errorCode, ", ",
                // res.errorMessage)
                callback(res.errorMessage, {
                    status: "failed",
                    data: res
                });
            },
            willMessage: willMessage,
            keepAliveInterval: 30,
            cleanSession: false,
            invocationContext: _this,
            useSSL: true
            // connect to mqtt server
        };mqttClient.connect(conOpts);

        _this.conOpts = conOpts;
        _this.mqttClient = mqttClient;
    };

    this.disconnect = function () {
        if (_this.totalClientConnections === 1) {
            console.log('MqttClient.disconnect called for clientId: ' + _this.clientId);
            if (_this.isConnected) {
                _this.autoConnect = false;
                _this.mqttClient.disconnect();
                _this.mqttClient = null;
                _this.clientId = "";
                _this.isConnected = false;
                _this.connectionObject = null;
                _this.totalClientConnections--;
                _this.topicSubscribers = [];
            }
        } else if (_this.totalClientConnections > 1) {
            _this.totalClientConnections--;
            console.log('Mqtt disconnected successfully');
            return;
        } else {
            console.warn('No active Mqtt connection found to disconnect');
        }
    };

    this.subscribe = function (config, callback) {
        var topicSubscription = _this.topicSubscribers[config.topic];
        if (topicSubscription) {
            _this.unsubscribe(config);
            topicSubscription.callbacks.push(config.callback);
        } else {
            var _topicSubscription = {
                callbacks: [config.callback]
            };
            _this.topicSubscribers[config.topic] = _topicSubscription;

            _this.mqttClient.subscribe(config.topic, {
                qos: config.qos,
                onSuccess: function onSuccess(rc) {
                    //console.log("MqttClient.subscribe onSuccess ", rc)
                    rc.topic = config.topic;
                    callback(null, {
                        status: "success",
                        data: rc
                    });
                },
                onFailure: function onFailure(res) {
                    // console.log("MqttClient.subscribe onFailure", res.errorCode, ", ",
                    // res.errorMessage)
                    callback(res.errorMessage, {
                        status: "fail",
                        data: res
                    });
                },
                timeout: 5
            });
        }
    };

    this.unsubscribe = function (config) {
        var topicSubscription = _this.topicSubscribers[config.topic];
        if (topicSubscription) {
            var callbacks = topicSubscription.callbacks.filter(function (callback) {
                return callback !== config.callback;
            });
            if (callbacks.length === 0) {
                // if no callback is available then remove the topicSubscription from topicSubscribers list
                delete _this.topicSubscribers[config.topic];
            } else {
                // add the remaining topicSubscription callbacks
                topicSubscription.callbacks = callbacks;
            }
        }
    };

    this.isMqttConnected = function () {
        return _this.isConnected;
    };

    this.publish = function (packet) {
        _this.mqttClient.send(packet.topic, packet.payload, packet.qos);
    };

    this.addConnectionStatusChangeCallback = function (callback) {
        if (typeof callback === 'function') {
            _this.connectionStatusChangeCallbacks.push(callback);
        }
    };

    this.removeConnectionStatusChangeCallback = function (callback) {
        _this.connectionStatusChangeCallbacks = _this.connectionStatusChangeCallbacks.filter(function (c) {
            return c !== callback;
        });
    };

    this._onConnectionLost = function (res) {
        console.log("MqttClient._onConnectionLost res: " + res.errorMessage);
        _this.isConnected = false;
        _this._connectionStatusChange(Constants.MQTT_OFFLINE);
        if (_this.autoConnect) {
            _this.reconnecthandle = setTimeout(function () {
                _this._reconnect();
            }, 500 * (2 ^ _this.reconnectCount));
        }
    };

    this._reconnect = function () {
        console.log('mqttclient reconnecting...' + ++_this.reconnectCount);
        clearTimeout(_this.reconnecthandle);

        _this.conOpts = Object.assign({}, _this.conOpts, {
            onSuccess: function onSuccess(res) {
                //console.log(`_reconnect() JSON.Stringify(${res})`)
                _this.isConnected = true;
                _this.reconnectCount = 0;
                _this._connectionStatusChange(Constants.MQTT_ONLINE);
            },
            onFailure: function onFailure(res) {
                console.log("_reconnect failed: " + res.errorMessage);
                _this._onConnectionLost(res);
            }
        });

        _this.mqttClient.connect(_this.conOpts);
    };

    this._onMessageArrived = function (packet) {
        var newPacket = Object.assign({}, packet, {
            topic: packet.destinationName,
            payload: packet.payloadString,
            qos: packet.qos
        });
        // console.log(`_onMessageArrived packet: ${JSON.stringify(packet)}`)
        var topicSubscription = _this.topicSubscribers[newPacket.topic];
        if (topicSubscription) {
            topicSubscription.callbacks.forEach(function (callback) {
                return callback(newPacket);
            });
        }
    };

    this._connectionStatusChange = function (status) {
        _this.connectionStatusChangeCallbacks.map(function (callback) {
            return callback({ clientId: _this.clientId, status: status });
        });
    };

    this.mqttClient = null;
    this.isConnected = false;
    this.isConnecting = false;
    this.autoConnect = true;
    this.port = "";
    this.host = "";
    this.clientId = "";
    this.topicSubscribers = [];
    this.connectionStatusChangeCallbacks = [];
    this.conOpts = null;
    this.reconnectCount = 0;
    this.reconnecthandle = null;
    this.totalClientConnections = 0;
    this.connectionObject = null;
}

// all private methods
;

exports.default = MqttClient;


// WEBPACK FOOTER //
// ../mqttclient/lib/mqttclient/mqttclient.js